import { Injectable } from '@angular/core';
import { Store, Query, StoreConfig } from '@datorama/akita';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { produce } from 'immer';


export interface SectionPartState {
  name: string;
  isInEditMode: boolean;
}

interface SectionState {
  name: string;
  parts: SectionPartState[];
}

export interface CsBuildupState {
  sections: SectionState[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'csBuildupUiState', producerFn: produce })
export class CsBuildupStateStore extends Store<CsBuildupState> {
  constructor() {
    super({ sections: [] });
  }
}

@Injectable({ providedIn: 'root' })
export class CsBuildupStateQuery extends Query<CsBuildupState> {
  constructor(protected store: CsBuildupStateStore) { super(store); }

  isSectionPartInEditMode(sectionName: string, sectionPartName: string): Observable<boolean> {
    return this
      .select(
        state => state.sections.find(section => section.name === sectionName)
          .parts.find(sectionPart => sectionPart.name === sectionPartName).isInEditMode)
      .pipe(distinctUntilChanged());
  }

  isAnySectionPartOfSectionInEditMode(sectionName: string): Observable<boolean> {
    return this
      .select(
        state => state.sections.find(section => section.name === sectionName)
          ?.parts.some(sectionPart => sectionPart.isInEditMode) ?? false)
      .pipe(distinctUntilChanged());
  }

  isAnySectionPartInEditMode(): Observable<boolean> {
    return this
      .select(
        state => state.sections.some(
          section => section.parts.some(sectionPart => sectionPart.isInEditMode)))
      .pipe(distinctUntilChanged());
  }
}
